export const formatAssessmentDate = (isoTimestamp: string): string => {
    const date = new Date(isoTimestamp);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    return `${year} ${month}`;
};
